import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";
import {createParentPositions, VANITY_TYPES} from "../../constants";
import {IS_LIXIL_SERVERS} from "../../../../../config";

export default class VanityHandle extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_handle';
    this.partName = 'Handle';
    this.translateId = "visualizer.bathroom.vanity.vanity_handle";
    this.dbName = "Vanity Handle";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = false;
    if (isChild) {
      createParentPositions(this);
    }
  }

  disabledClick() {
    const parent = this.getParent();
    if (!this.disabled && parent.vanityCabinet?.disabled) {
      parent.toggleVanityParts(this.disabled);
    }
  }

  hideLayerCondition() {
    const vanityParent = this.getParent();
    return !vanityParent.vanityCabinet || vanityParent.vanityCabinet.disabled || !vanityParent.vanityCabinet.activeFeature
      || vanityParent.vanity_type !== VANITY_TYPES.vanity_cabinet
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const vanityParent = this.getParent();
    conditions.push({
      propName: "VanitySize",
      propValue: vanityParent.counterTopSize(this)
    })
    if (IS_LIXIL_SERVERS) { // not sure if it is needed, this is old logic
      conditions.push({
        propName: "CabinetStyle",
        propValue: vanityParent.vanityCabinet && vanityParent.vanityCabinet.activeFeature
        && vanityParent.vanityCabinet.activeFeature.metaData["CabinetStyle"]
          ? vanityParent.vanityCabinet.activeFeature.metaData["CabinetStyle"]
          : "No handles" // if no cabinet style - hide handles
      });
    } else {
      if (vanityParent.vanityCabinet && vanityParent.vanityCabinet.activeFeature
        && vanityParent.vanityCabinet.activeFeature.metaData["HandlePosition"]) {
        conditions.push({
          propName: "HandlePosition",
          propValue: vanityParent.vanityCabinet.activeFeature.metaData["HandlePosition"]
        });
      }
    }
    return conditions
  }
}
